import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import OutlineInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import {pickAttributes} from '../../../../helpers/utils'

const useStyles = makeStyles(textStyles)

export default function TextInput(props) {

  const classes = useStyles()

  const errorId = `${props.id}-error-text`


  return (
    <Box className={clsx(classes.root, props.className)}>
      <Box className={clsx(classes.label, "label")}>{props.caption}:</Box>
      <Box className={clsx(classes.input, "input")}>
        <FormControl
          {...pickAttributes(props, 'control')}
          className={classes.control}
        >
          <OutlineInput
            id={props.id}
            aria-describedby={errorId}
            value={props.value}
            {...pickAttributes(props, 'input')}
            className={classes.input}
          >
          </ OutlineInput>
          <FormHelperText id={errorId} {...pickAttributes(props, 'error')}>{props.errorMessage}</FormHelperText>
        </FormControl>
      </Box>
    </Box>
  )
}

function textStyles(theme) {
  return {
    root: {
    },
    control: {
      margin: 0,
      flexGrow: 1
    },
    input: {
      "& input": {
        padding: 10
      }
    }
  }
}
